<template>
  <div class="announcement">
    <div class="anno-swiper">
      <div class="swiper-wrapper">
        <template v-for="(row,index) in 4">
          <template v-if="index*2<articleList.length">
            <div class="swiper-slide">
              <div class="anno-item-panel">
                <div class="anno left" v-if="articleList[index*2]">
                  <div class="anno-item" @click="open(articleList[index*2].url)">
                    {{articleList[index*2].title}}
                  </div>
                </div>
                <div class="split" v-if="articleList[index*2+1]">/</div>
                <div class="anno right" v-if="articleList[index*2+1]">
                  <div class="anno-item" @click="open(articleList[index*2+1].url)">
                    {{articleList[index*2+1].title}}
                  </div>
                </div>
              </div>
            </div>
          </template>
        </template>
      </div>
    </div>
    <a :href="`https://support.bitforex.com/hc/${curLang}/sections/360001541712`" target="_blank"
       rel="external nofollow noopener noreferrer" class="more ripple-effect">
      <div class="text-btn">more ></div>
    </a>
  </div>
</template>

<script>
  import {getListAnnouncement} from '~/model/clientStaticModel.js';
  import {mapState} from 'vuex';
  import Swiper from 'swiper/bundle';
  import 'swiper/swiper-bundle.css';
  export default {
    name: 'index',
    data () {
      return {
        list: [],
        articleList: [],
        config: {
          grabCursor: true,
          loop: true,
          speed: 500,
          slidesPerView: 1,
          observer: true,
          observeParents: true,
          direction:'vertical',
          autoplay: {
            pauseOnMouseEnter: true,
            delay: 4000,
            stopOnLastSlide: false,
            disableOnInteraction: false
          },
        }
      };
    },
    computed: {
      ...mapState({
        locale: state => state.common.locale
      }),
      curLang () {
        switch (this.locale) {
          // case 'cn':
          //   return 'zh-cn';
          case 'hk':
            return 'zh-tw';
          case 'kr':
            return 'ko';
          case 'ru':
            return 'ru';
          case 'pt-br':
            return 'en-us';
          case 'jp':
            return 'ja';
          // case 'vn':
          //   return 'vi';
          default:
            return 'en-us';
        }
      }
    },
    async mounted () {
      await this.getArticle(1);
      await this.getArticle(2);
      await this.getArticle(3);
      await this.getArticle(4);
      this.$nextTick(() => {
        if ( this.articleList.length >= 2) {
          new Swiper('.anno-swiper', this.config);
        }
      });
    },
    methods: {
      open (url) {
        window.open(url);
      },
      async getArticle (type) {
        let res = await getListAnnouncement({lang: this.curLang, type});
        if (res.success === true) {
          this.list.push(...res.data)
          let a = this.list;
          for(let i = 0; i < a.length; i++){
            for(let j = 0; j < a.length; j++){
              if (j < a.length - 1 && a[j].edited_at < a[j+1].edited_at) {
                let b = a[j];
                a[j] = a[j+1];
                a[j+1] = b;
              }
            }
          }
          this.articleList = a.slice(0, 4) || [];
        }
      },
      changeIndex (index) {
        this.activeIndex = index;
        this.getArticle(index);
      }
    }
  };
</script>

<style scoped lang="scss">

  .announcement {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 24px;
    .name {
        width: 170px;
        text-align: right;
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 19px;
        color: #000000;
    }
    .anno-swiper {
      height: 20px;
      overflow: hidden;
      width: 920px;

      .anno-item-panel{
        width: 100%;
        display: flex;
        height: 20px;
        align-items: center;
        .split {
          margin-right: 27px;
          margin-left: 27px;
        }

        .anno{
          height: 20px;
          display: flex;
          align-items: center;
          .anno-item {
            font-style: normal;
            font-weight: normal;
            font-size: 16px;
            line-height: 19px;
            color: #000000;
            cursor: pointer;
            max-width: 510px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;

            &:hover {
              color: var(--COLOR-brand);
            }
          }
        }
      }

    }

    .text-btn {
      text-align: right;
      width: 80px;
      font-style: normal;
      font-weight: bold;
      font-size: 14px;
      line-height: 16px;
      color: #8C8CA2;
      opacity: 0.5;
    }
    &:hover{
      .text-btn{
        color: #14C393;
      }
    }
  }
  @media screen and (max-width: 1199px) {
  .announcement{
    width: 834px;
    margin: 24px auto;
  }
}

</style>

